import { FormattedMessage } from "react-intl";
import { useReceiveDrawerContext } from "../inventory-context";
import { SideDrawer } from "../side-drawer";
import { ReceiveForm } from "./receive-form";

export function ReceiveDrawer() {
  const { isOpen, closeMenu } = useReceiveDrawerContext();

  return (
    <SideDrawer
      isOpen={isOpen}
      closeDrawer={closeMenu}
      title={
        <FormattedMessage
          id="inventory.receiveDrawer.title"
          defaultMessage="Receive"
        />
      }
      drawerData-testId="receiveDrawerContainer"
      closeIconData-testId="receiveDrawerCloseIcon"
    >
      <ReceiveForm />
    </SideDrawer>
  );
}
